<template>
  <div class="flex flex-col gap-4 py-10">
    <VContainer v-if="cart?.products && cart.products.length > 0">
      <h1 class="text-2xl font-bold mb-4">{{ t('Cart') }}</h1>
      <div class="grid grid-cols-1 xl:grid-cols-[1fr_400px] gap-4">
        <div class="flex flex-col gap-4">
          <VCartItem v-for="product in cart.products" :key="`${product.id_product}-${product.id_product_attribute}-${product.cart_quantity}`" :product="product" />
        </div>
        <div>
          <div class="sticky top-10 bg-white rounded border shadow p-4 flex flex-col gap-4 md:max-w-100 ml-auto w-full">
            <div>
              <dl class="text-lg">
                <div class="flex w-full">
                  <dt class="font-medium w-32">{{ t('Subtotal') }}</dt>
                  <dd class="text-right w-full text-gray-800">
                    <span class="text-sm">({{ cart.subtotals?.tax.label }})</span> {{ cart.subtotals.products?.value }}
                  </dd>
                </div>
                <div class="flex w-full" v-if="cart.subtotals?.discounts?.value">
                  <dt class="font-medium w-32">{{ t('Discount') }}</dt>
                  <dd class="text-right w-full text-gray-800">-{{ cart.subtotals.discounts?.value }}</dd>
                </div>
                <div class="flex w-full text-gray-700 text-sm">
                  <dt class="font-medium w-full">{{ t('Taxes included') }}</dt>
                  <dd class="text-right w-full">{{ cart.subtotals?.tax?.value }}</dd>
                </div>
                <div class="flex w-full mt-3">
                  <dt class="font-medium w-32">{{ t('Shipping') }}</dt>
                  <dd class="text-right w-full text-gray-800">{{ cart.subtotals.shipping?.value }}</dd>
                </div>
                <p class="text-sm mb-3 text-gray-700">
                  {{ t('Cost of the shipping will be calculated again during checkout') }}
                </p>
                <div class="flex w-full">
                  <dt class="font-medium w-32">{{ t('Total') }}</dt>
                  <dd class="text-right w-full text-gray-800">{{ cart.totals.total?.value }}</dd>
                </div>
              </dl>
            </div>
            <NuxtLink :to="localePath('checkout')" class="btn btn-primary">
              {{ t('Proceed to checkout') }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </VContainer>
    <VEmptyState
      v-else
      :title="t('No products in the cart')"
      :description="t('Please add some products to the cart to continue')"
      :link="localePath('/')"
      :link-text="t('Go to homepage')"
    />
  </div>
</template>

<script setup lang="ts">
import type { PsCart } from '@vue-storefront/prestashop-api';

const localePath = useLocalePath();

const { data: cart } = useCart();
const { addOrRemoveFromCart } = useAnalytics();
const { t } = useI18n();

useSeoMeta({ title: t('Cart') });

onMounted(() => {
  const psCart = cart.value as PsCart;
  if (psCart?.products) {
    addOrRemoveFromCart(psCart.products, 'view_cart');
  }
})
</script>
